import type { Step } from './step';
import type { LocalizedContent } from './localizedContent';

export class Demo {
  public readonly id: string = '';
  public readonly name: string = '';
  public readonly steps: Step[] = [];
  public readonly localizations: LocalizedContent[] = [];

  constructor(props: Partial<Demo> = {}) {
    Object.assign(this, props);
  }
}
